import React from 'react';
import { Heart } from 'lucide-react';

export const AccessibilityBanner: React.FC = () => {
  return (
    <div className="no-print bg-slate-100 border-b border-slate-200 py-2 px-4 text-xs md:text-sm text-slate-700">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Heart className="w-4 h-4 text-indigo-600 fill-indigo-100 shrink-0" />
          <span>
            <strong>Welcome, Family!</strong> Click any person card to view photos, stories, and listen to spoken memories.
          </span>
        </div>

        <div className="flex items-center gap-4 text-xs">
          <span className="hidden lg:inline text-slate-500">
            💡 Tip: Use the <strong>"Voice Reader"</strong> button at top right to hear any story spoken out loud.
          </span>
        </div>
      </div>
    </div>
  );
};
